/**
 * Authentication Service
 */

import apiFetch, { setToken, removeToken, getToken } from './api';

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  token_type: string;
  user: {
    id: number;
    username: string;
    email: string;
    is_superuser: boolean;
  };
}

export interface RegisterData {
  email: string;
  username: string;
  password: string;
}

export const authService = {
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await apiFetch('/api/v1/auth/login', {
      method: 'POST',
      body: JSON.stringify(credentials),
    });

    setToken(response.access_token);
    return response;
  },

  async register(data: RegisterData): Promise<any> {
    return apiFetch('/api/v1/auth/register', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async getCurrentUser(): Promise<any> {
    return apiFetch('/api/v1/auth/me');
  },

  logout(): void {
    removeToken();
    // Dynamische redirect gebaseerd op omgeving
    window.location.href = '/login';
  },

  isAuthenticated(): boolean {
    return getToken() !== null;
  },
};
